// config/env.js
export const config = {
  firebaseFunctionsBaseUrl: process.env.REACT_APP_FIREBASE_FUNCTIONS_BASE_URL,
  simulationMode: process.env.REACT_APP_SIMULATION_MODE === 'true',
  unregisteredCustomerBookingEnabled: process.env.REACT_APP_UNREGISTERED_CUSTOMER_BOOKING_ENABLED === 'true',
  customerExists: process.env.REACT_APP_CUSTOMER_EXISTS === 'true',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};

// Validation helper
export const validateConfig = () => {
  const required = ['firebaseFunctionsBaseUrl'];
  
  for (const key of required) {
    if (!config[key]) {
      throw new Error(`Missing required environment variable: ${key}`);
    }
  }
};

// Usage in components
export const useConfig = () => config;